import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, base_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Check your inbox" subtitle="We've sent you a password reset link.">
        <div className="space-y-4" data-testid="forgot-sent-panel">
          <div className="flex items-center gap-3 rounded-xl border border-accent/30 bg-accent/5 p-4">
            <MailCheck className="h-5 w-5 shrink-0 text-accent" />
            <p className="text-sm text-muted-foreground">If an account exists for <span className="font-semibold text-foreground">{email}</span>, a reset link is on its way. The link expires in 1 hour.</p>
          </div>
          <Link to="/login"><Button variant="outline" className="w-full" data-testid="back-to-login-button">Back to log in</Button></Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Forgot your password?" subtitle="Enter your email and we'll send you a reset link.">
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" placeholder="you@company.com" />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="forgot-error">{error}</p>}
        <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
        </Button>
        <p className="text-center text-sm text-muted-foreground">
          Remembered it? <Link to="/login" className="font-semibold text-accent hover:underline" data-testid="go-login-link">Log in</Link>
        </p>
      </form>
    </AuthShell>
  );
}
